import styled from "styled-components";
import C from "@assets/themes/colors";
import D from "@assets/themes/dimensions";

interface IStyleProps {
  displayValue?: string;
  topValue?: number;
  rightValue?: number;
  widthValue?: number;
  heightValue?: number;
  cellWidth?: number;
  cellHeight?: number;
}

export const Root = styled.div`
  z-index: 100;
  cursor: none;
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
`;

export const EyeDropperContainer = styled.div`
  position: fixed;
  padding: 200px;
  width: 16px;
  height: 16px;
  z-index: 110;
`;

export const Preview = styled.div`
  display: ${(props: IStyleProps) => (props.displayValue ?? 'auto')};
  position: fixed;
  right: 25px;
  top: ${D.APP_BAR_HEIGHT + D.COMMAND_BAR_HEIGHT + 57}px;
`;

export const CanvasContainer = styled.div`
  width: ${(props: IStyleProps) => (props.widthValue ?? 100)}px;
  height: ${(props: IStyleProps) => (props.heightValue ?? 100)}px;
  border-radius: 50%;
  overflow: hidden;
`;

export const Canvas = styled.canvas`
`;

export const Grid = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-sizing: border-box;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px rgba(255, 255, 255, 0.5);
  background-image:
    linear-gradient(to right, rgba(0, 0, 0, 0.2) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 1px, transparent 1px);
  background-position: ${(props: IStyleProps) => ((props.cellWidth ? props.cellWidth / 2 : 5) - 1)}px ${(props: IStyleProps) => ((props.cellHeight ? props.cellHeight / 2 : 5) - 1)}px;
  background-size: ${(props: IStyleProps) => (props.cellWidth ?? 10)}px ${(props: IStyleProps) => (props.cellHeight ?? 10)}px;
`;

export const ColorStroke = styled.div`
  position: absolute;
  top: ${(props: IStyleProps) => (props.topValue ?? 45)}px;
  right: ${(props: IStyleProps) => (props.rightValue ?? 44)}px;
  width: ${(props: IStyleProps) => ((props.cellWidth ?? 10) + 1)}px;
  height: ${(props: IStyleProps) => ((props.cellWidth ?? 10) + 1)}px;
  box-sizing: border-box;
  border: solid 1px rgba(0, 0, 0, 0.6);
`;

export const Label = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  right: ${(props: IStyleProps) => (props.rightValue ?? 15)}px;
  bottom: -27px;
  width: 70px;
  height: 17px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.5);
`;